$(function () {
    let icsFile = null;
    createFile();

    function createFile() {
        const eventDateElement = $('.events-date')
        const eventStartDateTime = eventDateElement.attr('data-eventStartDate');
        const eventEndDateTime = eventDateElement.attr('data-eventEndDate');

        const [ eventStartDate, eventStartTime] = eventStartDateTime.split(' ');
        const [ eventEndDate, eventEndTime] = eventEndDateTime.split(' ');

        const title = $('.topTeaser__header').text().trim();
        const description = $('.teaser-text').text().trim();
        const location = eventDateElement.attr('data-location');
        const event = {
            start: parseDateTime(eventStartDate, eventStartTime),
            end: parseDateTime(eventEndDate, eventEndTime),
            created: new Date(),
            title,
            description,
            location,
        };

        const link = $(".downloadIcs");
        link.attr('href', makeIcsFile(event));
    }

    function parseDateTime(date, time) {
        const parts = date.match(/(\d+)/g);
        const [h, m] = time.split(':');
        return new Date(Date.UTC(parts[2], parts[1]-1, parts[0], h,  m,0));
    }


    function convertDate(data) {
        let event = new Date(data).toISOString();
        event = event.replaceAll('-','' );
        let [date, time] = event.split('T');
        time = time.replaceAll(':', '').split('.')
        return date +'T'+ time[0];
    }

    function generateUIid(startDate) {
        return convertDate(startDate)+ parseInt(Math.floor(100000 + Math.random() * 900000)).toString().substring(0,4);
    }

    function makeIcsFile(data) {
        const calendar =
            "BEGIN:VCALENDAR\n" +
            "PRODID:-//Fifa Training Center //EN\n" +
            "VERSION:2.0\n" +
            "CALSCALE:GREGORIAN\n" +
            "METHOD:PUBLISH\n" +
            "BEGIN:VTIMEZONE\n" +
            "TZID:Etc/GMT\n" +
            "LAST-MODIFIED:20220317T223602Z\n" +
            "TZURL:http://tzurl.org/zoneinfo-outlook/America/New_York\n" +
            "X-LIC-LOCATION:Etc/GMT\n" +
            "BEGIN:STANDARD\n" +
            "TZNAME:GMT\n" +
            "TZOFFSETFROM:+0000\n" +
            "TZOFFSETTO:+0000\n" +
            "DTSTART:19701101T020000\n" +
            "END:STANDARD\n" +
            "END:VTIMEZONE\n"+
            "BEGIN:VEVENT\n" +
            "UID:"+generateUIid(data.start)+
            "\n" +
            "DTSTART;TZID=Etc/GMT:" +
            convertDate(data.start) +
            "\n" +
            "DTEND;TZID=Etc/GMT:" +
            convertDate(data.end) +
            "\n" +
            "DTSTAMP:"+
            convertDate(data.created) +
            "\n" +
            "SUMMARY:" +
            data.title +
            "\n" +
            "DESCRIPTION:" +
            data.description +
            "\n" +
            "LOCATION:" +
            data.location +
            "\n"+
            "TRANSP:OPAQUE\n"+
            "TZID:Etc/GMT\n"+
            "ORGANIZER;EN:Fifa Training Center\n"+
            "END:VEVENT\n" +
            "END:VCALENDAR";

        const file = new File([calendar], {type: "text/plain"});
        if (icsFile !== null) {
            window.URL.revokeObjectURL(icsFile);
        }
        icsFile = window.URL.createObjectURL(file);
        return icsFile;
    }

});

